import { render, staticRenderFns } from "./DataSourceSettings.vue?vue&type=template&id=73def4db&scoped=true"
import script from "./DataSourceSettings.vue?vue&type=script&lang=js"
export * from "./DataSourceSettings.vue?vue&type=script&lang=js"
import style0 from "./DataSourceSettings.vue?vue&type=style&index=0&id=73def4db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73def4db",
  null
  
)

export default component.exports